const mobileNavigation = (width) => {

    const button                = $('.js-mobile-nav-button');
    const sidebar               = $('.js-mobile-sidebar');
    const activeClass           = '_nav-opened';

    const navigation            = $('.js-mobile-navigation');
    const navigationLevel       = $('.js-mobile-navigation-level');
    const navigationLink        = $('.js-mobile-navigation-link');
    const navigationLinkBack    = $('.js-mobile-navigation-link-back');
    const navigationLinkBackVal = $('.js-mobile-navigation-link-back-value');
    const navigationActiveClass = '_active';
    const linkBackActiveClass   = '_link-back-visible';
    let right                   = 0;

    button.on('click', function(){
        if ( !APP.websiteWrapper.hasClass(activeClass) ) {
            APP.websiteWrapper.addClass(activeClass);
        }
        else {
            right = 0;
            navigation.css('right', right * 100 + '%');
            sidebar.removeClass(linkBackActiveClass);
            navigationLevel.removeClass(navigationActiveClass);
            navigationLinkBackVal.val('');
            APP.websiteWrapper.removeClass(activeClass);
        }
    });

    //go to sublevel
    navigationLink.on('click', function(e) {
        e.preventDefault();
        if ( $(this).parents('.js-mobile-navigation-element').children().length >= 2 ) {
            right++;
            $(this).parents('.js-mobile-navigation-element').children('.js-mobile-navigation-level').addClass(navigationActiveClass);
            navigation.css('right', right * 100 + '%');
        }

        //show link back and change it's title
        const levelTitle     = $(this).attr('data-level-title');
        sidebar.addClass(linkBackActiveClass);
        navigationLinkBackVal.text(levelTitle);
    });

    //go back to previous level
    navigationLinkBack.on('click', function(e) {
        e.preventDefault();
        right--;
        navigation.css('right', right * 100 + '%');
        $('.js-mobile-navigation-level.'+navigationActiveClass).last().removeClass(navigationActiveClass);

        const level      = $('.js-mobile-navigation-level.'+navigationActiveClass);
        const levelTitle = level.last().parent('.js-mobile-navigation-element').find('.mobile-navigation__link-value').eq(0).text();
        navigationLinkBackVal.text(levelTitle);

        if (right < 1) {
            sidebar.removeClass(linkBackActiveClass);
        }
    });

    $(document).on('mouseup touchend', function(e){
        if (!sidebar.is(e.target) && sidebar.has(e.target).length === 0 && !button.is(e.target) && button.has(e.target).length === 0 ) {
            right = 0;
            navigation.css('right', right * 100 + '%');
            sidebar.removeClass(linkBackActiveClass);
            navigationLevel.removeClass(navigationActiveClass);
            navigationLinkBackVal.val('');
            APP.websiteWrapper.removeClass(activeClass);
        }
    });
    $(window).on('load resize', function(){
        if ( window.deviceWidth > width ) {
            APP.websiteWrapper.removeClass(activeClass);
        }
    });
}